<div class="all-allergens-main-container">
    <!-- <div class="close_icon_div">
        <img src="../../../../assets/img/close-icon-allergens.svg" alt="" (click)="close()">
    </div> -->
    <div class="allergens_heading">
        Allergens
        <div class="tooltip" *ngIf="data.allergens_msg">
            <img src="../../../../assets/img/quill_info.svg" alt="" style="cursor: pointer;">
            <span class="tooltiptext tooltipRankUp"><span>{{data.allergens_msg}}</span></span>
        </div>
        
    </div>
    <div class="horizontal_line_div">&nbsp;</div>
    <div class="allergen_dish_name_div">{{allData.dish_name.name}}</div>
    <div class="all_allergens_list_main_div">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col-1">Allergens</th>
                    <th scope="col-1">Option Available</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of allData.dish_allergens">
                    <tr>
                        <th scope="row">
                            <div class="allergen_list_ele" [ngClass]="{'allergen_active': item.is_common}">{{item.allergens_name}}</div>
                        </th>
                        <td>
                            <div class="allergen_list_ele">{{item.is_allergens_option ? 'Yes' : 'No'}}</div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <!-- <ng-container *ngFor="let item of allData.dish_allergens">
            <div class="allergen_list_ele" [ngClass]="{'allergen_active': item.is_common}">{{item.allergens_name}}</div>
        </ng-container> -->
    </div>
    

</div>






<style>
    ::ng-deep .mat-bottom-sheet-container {
        padding: 0px !important;
        box-sizing: border-box;
        display: block;
        outline: 0;
        max-height: 600vh !important;
        overflow: visible !important;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        max-width: 380px;
    }

    .all-allergens-main-container {
        max-height: 400px;
        overflow: scroll;
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 200px;
        padding-bottom: 10px;
    }

    .close_icon_div {
        position: fixed;
        top: -40px;
        left: 0;
        right: 0;
        text-align: center;
    }

    .close_icon_div img {
        cursor: pointer;
    }

    .allergens_heading {
        color: #54AC58;
        font-weight: 500;
        font-size: 18px;
        padding: 15px 0;
        text-align: center;
        display: flex;
        gap: 10px;
        justify-content: center;
    }

    .horizontal_line_div {
        margin: 0 10px;
        background-color: #EFEFEF;
        height: 3px;
        /* width: 100%; */
    }

    .allergen_dish_name_div {
        background-color: #F2F5F7;
        padding: 5px 10px;
        font-size: 14px;
        font-weight: 500;
        margin: 10px 0;
        margin-bottom: 0;
        text-transform: capitalize;
    }

    .all_allergens_list_main_div {
        flex: 1;
        overflow: auto;
        padding-top: 10px;
        /* padding-left: 2rem; */
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
    }

    .allergen_list_ele {
        /* margin-bottom: 10px; */
        color: #707070;
        font-size: 14px;
    }

    .allergen_active {
        color: #FA4747;
    }
    .all_allergens_list_main_div .table th, .all_allergens_list_main_div .table td {
      width: 50%;
      text-align: center;
    }




    .all-allergens-main-container .tooltip {
        position: relative;
        display: inline-block;
        opacity: 1 !important;
        z-index: 11 !important;
        cursor: pointer;
    }

    .all-allergens-main-container .tooltip .tooltiptext {
        visibility: hidden;
        background-color: #F4FFF4;
        color: #4E4E4E;
        text-align: center;
        border-radius: 9px;
        padding: 10px;
        position: absolute;
        letter-spacing: 0.3px;
        font-family: 'Roboto';
        top: 29px;
        left: -8.4em;
        transition: opacity 0.3s;
        width: max-content;
        min-width: 150px;
        max-width: 250px;
        font-size: 14px;
        box-shadow: -3px 3px 6px rgba(98, 98, 98, 0.15);
    }

    .all-allergens-main-container .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }
</style>